import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap";
import React from "react";
import { NotificationLogo } from "./logos";
import { useDispatch, useSelector } from "react-redux";
import {
  setCheckinPopupOpen,
  setExpiringTodayPopupOpen,
} from "../redux/actions/gym/gymAction";
import { setMembershipCardsScannerPopupOpen } from "../redux/actions/membershipCard/membershipCardAction";
import { getExpiringToday } from "../redux/actions/api/apiAction";

export const FloatingDropUp = ({ checkinData }) => {
  const dispatch = useDispatch();
  const { membershipCardsScannerPopupOpen } = useSelector(
    (state) => state.membershipCard
  );
  const { features } = useSelector((state) => state.features);
  const { gymConfig } = useSelector((state) => state.gym);

  const checkinsAction = () => dispatch(setCheckinPopupOpen(true));
  const handleExpiringToday = () => {
    dispatch(setExpiringTodayPopupOpen(true));
    dispatch(getExpiringToday());
  };
  const membershipCardsScannerAction = () => {
    dispatch(setMembershipCardsScannerPopupOpen(true));
  };
  const newCheckinsLength = checkinData.reduce((sum, itm) => {
    return !itm.viewed ? sum + 1 : sum;
  }, 0);

  const allItemsDisabled = !(gymConfig?.gates?.enabled && gymConfig?.gates?.accessBy == "RFIDCards") && !gymConfig?.manageMemberships?.scannerCheckIn && !gymConfig?.manageMemberships?.expiringToday;

  return (
    <div className="floating-container">
      {newCheckinsLength > 0 && (
        <p className="badge badge-danger notification-floating-indicator">
          {newCheckinsLength}
        </p>
      )}
      <UncontrolledDropdown
        className=""
        direction="up"
        onClick={() => {
          if (membershipCardsScannerPopupOpen)
            dispatch(setMembershipCardsScannerPopupOpen(false));
        }}
      >
        {!allItemsDisabled && 
        <DropdownToggle className="floatingDropUp">
          <NotificationLogo />
        </DropdownToggle>
        }
        <DropdownMenu>
          {gymConfig?.gates?.enabled && gymConfig?.gates?.accessBy == "RFIDCards" ? (
              <DropdownItem
                onClick={membershipCardsScannerAction}
                className="py-3"
              >
                Scan Member
              </DropdownItem>
            ) :
            <div className="py-3"></div>
          }
          {
            gymConfig?.manageMemberships?.scannerCheckIn ? 
            <DropdownItem onClick={checkinsAction} className="py-3">
              Scanner Check-ins
              {newCheckinsLength > 0 && (
                <span className="badge badge-danger inner-notification-indicator">
                  {newCheckinsLength}
                </span>
              )}
            </DropdownItem> 
            :
            <div className="py-3"></div>
          }
          <DropdownItem divider />
          {
            gymConfig?.manageMemberships?.expiringToday ?
            <DropdownItem onClick={handleExpiringToday} className="py-3">
              Expiring today
            </DropdownItem>
            :
            <div className="py-3"></div>
          }
        </DropdownMenu>
      </UncontrolledDropdown>
    </div>
  );
};
